import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import fonts from 'ts/studio/fonts';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    inputAnatomy.keys
);

const baseStyle = definePartsStyle({
    fontFamily: fonts.heading,
    field: {
        fontSize: '16px',
        color: 'neutral.600'
    },
    element: {
        fontSize: '1.2rem',
        color: 'gray.500'
    }
});

const variants = {
    withAddon: definePartsStyle({
        addon: {
            background: 'gray.600',
            backgroundColor: 'gray.600',
            border: `1px solid`,
            borderColor: 'gray.600',
            borderRadius: '4px',
            color: 'white',
            fontSize: '16px',
            height: 'inherit',
            paddingLeft: '10px',
            paddingRight: '10px'
        },
        field: {
            border: '1px solid',
            borderColor: 'gray.600'
        }
    })
};

export const inputTheme = defineMultiStyleConfig({
    baseStyle,
    variants
});
